/**
 * セッションのキーを表します。
 */
export class CommonStorageKey {

  /** 法人ID */
  public static readonly HOUJINID: string = 'HOUJINID';

  /** ユーザID */
  public static readonly YUZAID: string = 'YUZAID';

  /** グループコード */
  public static readonly GURUPUCODE: string = 'GURUPUCODE';

  /** グループ区分 */
  public static readonly GURUPUKUBUN: string = 'GURUPUKUBUN';

  /** ユーザ連携区分 */
  public static readonly YUZARENKEIKUBUN: string ='YUZARENKEIKUBUN';
  /** 会社名 */
  public static readonly KAISHAMEI: string = 'KAISHAMEI';

  /** 支店名 */
  public static readonly SHITENMEI: string = 'SHITENMEI';

  /** 前回最終ログイン日時 */
  public static readonly ZENKAIROGUINNICHIJI: string = 'ZENKAIROGUINNICHIJI';

  /** ユーザ名称 */
  public static readonly YUZAMEISHO: string = 'YUZAMEISHO';

  /** リターンコード */
  public static readonly RTNCODE: string = 'RTNCODE';

  /** 処理年度 */
  public static readonly SHORINENDO: string = 'SHORINENDO';

  /** 処理年月 */
  public static readonly SHORINENGETSU: string = 'SHORINENGETSU';

  /** 処理日 */
  public static readonly SHORIBI: string = 'SHORIBI';

  /** メッセージ管理 */
  public static readonly MESSAGEKANRILIST: string = 'MESSAGEKANRILIST';

  /** セッションID */
  public static readonly SESHONID: string = 'SESHONID';

  /** 画面ID */
  public static readonly GAMENID: string = 'GAMENID';

  /** メニューの高さ */
  public static readonly LEFTMENUHEIGHT: string = 'LEFTMENUHEIGHT';

  /** ホーム画面の遷移元画面 */
  public static readonly HOMESENIMOTO: string = 'HOMESENIMOTO';

  /** 代行フラグ */
  public static readonly DAIKOUFLG: string = 'DAIKOUFLG';

  /** メッセージID */
  public static readonly MSGID: string = 'MSGID';

  /** メッセージ本文 */
  public static readonly MSGHONBUN: string = 'MSGHONBUN';

  /** エラー画面メッセージ */
  public static readonly NEMESSAGE: string = 'NEMESSAGE';

  /** ロールＩＤ */
  public static readonly RORUID: string = 'RORUID';

  /** 設定権限 */
  public static readonly KENGENLIST: string = 'KENGENLIST';

  /** ユニークID */
  public static readonly UNIQUEID: string = 'UNIQUEID';

  /** 環境依存文字チェックメッセージ  */
  public static readonly MSGINFO: string = 'MSGINFO';

  // ST-403 Start
  /** タイマー算出差分値  */
  public static readonly TIMERADD: string = 'TIMERADD';
  // ST-403 End
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/const/common-storage-key.ts